import { useMutation } from '@tanstack/react-query'
import { getExportLineItems } from '@/api/processes-api'
import type { ProcessesApiFindExportLineItemsRequest } from '@itsrever/dashboard-api'

const exportItemsCsv = async (
  filters: ProcessesApiFindExportLineItemsRequest
) => {
  const data = await getExportLineItems(filters)

  return data
}

export const useExportItemsCsv = () => {
  return useMutation({
    mutationFn: exportItemsCsv
  })
}
